import { Injectable } from '@angular/core';
//import { Observable } from 'rxjs/Observable';
import { Observable, of } from 'rxjs';
//import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/do';
//import 'rxjs/add/operator/catch';
import { IPagination } from '../_interfaces/pagination'
import { IAnlagenbeschreibung } from '../_interfaces/anlagenbeschreibung';
//import { IChoiceList } from '../_interfaces/_choice-list';
import * as moment from 'moment'; // DateTimeOffset-Fix
import * as cloneDeep from 'lodash/cloneDeep'; // DateTimeOffset-Fix

import { AppconfigService } from '../_services/appconfig.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

import { CRUDBasicService, httpOptions } from '../_services/crud-basic.service';

@Injectable()
export class AnlagenbeschreibungService extends CRUDBasicService {

  //typeOf deprecated -> CRUDBasicService.propertyTypeOf
  /*typeOf(propertyName: string) {  // welchen Typs sind die Properties IN DER API ?
    let property = this.propertyTypes.find(f => f.name == propertyName);
    if(property != null) return property.type;
    else return null;    
  }*/
  propertyTypes = [ // welchen Typs sind die Properties IN DER API ?
    {name: 'anlagentyp', type: 'string'},
    {name: 'bezeichnung', type: 'string'},
    {name: 'createdBy', type: 'string'},
    {name: 'created', type: 'DateTimeOffset'},
    {name: 'modifiedBy', type: 'string'},
    {name: 'modified', type: 'DateTimeOffset'},
    {name: 'rowVersion', type: 'byte[]'},
    {name: 'summary', type: 'string'}
  ];
    
  getAnlagenbeschreibungenCollection(pageNumber: number, pageSize: number, searchQuery: string): Observable<{ anlagenbeschreibungen: IAnlagenbeschreibung[], pagination: IPagination }> {
    return this.httpClient.get(this.apiBaseUrl + 'anlagenbeschreibung?pageNumber=' + pageNumber + '&pageSize=' + pageSize + '&searchQuery=' + searchQuery, { headers: httpOptions, observe: 'response', withCredentials: true })
      .pipe(
        map((response) => {
          return { anlagenbeschreibungen: <IAnlagenbeschreibung[]>response.body, pagination: /*<IPagination>JSON.parse(response.headers.get('x-pagination'))*/this.getDummyPagination((<any[]>response.body).length) };
        }), catchError(this.handleError))
  }

  getAnlagenbeschreibung(id: number): Observable<IAnlagenbeschreibung> {

    if (id === 0) {
      return Observable.create((observer: any) => {
        observer.next(this.initializeAnlagenbeschreibung());
        observer.complete();
      })
    }

    return this.httpClient.get<IAnlagenbeschreibung>(this.apiBaseUrl + 'anlagenbeschreibung/' + id, { headers: httpOptions, observe: 'body', withCredentials: true })
      .pipe(map((response) => response), catchError(this.handleError));
  }

  /*saveAnlagenbeschreibung(anlagenbeschreibung: IAnlagenbeschreibung): Observable<IAnlagenbeschreibung> {
    // DateTimeOffset-Fix
    let itemToSave = cloneDeep(anlagenbeschreibung); // clonen, um sicherzustellen, dass das Original-Objekt nicht ver�ndert wird, evtl. passiert nach dem Save noch etwas damit ?
    //console.log("AnlagenbeschreibungService.saveSingularCapitalized#() itemToSave before DateTimeOffset-Fix:", itemToSave);
    this.propertyTypes.filter(f => f.type.toLowerCase() == 'datetimeoffset').forEach(propertyType => {
      if (itemToSave[propertyType.name] != null) {
        itemToSave[propertyType.name] = moment(itemToSave[propertyType.name]).format('YYYY-MM-DDTHH:mm:ss.SSSZ'); // alle datetimeoffset-felder entspr. formatieren, dass in der API auch der Offset ankommt!
      }
    });
    //console.log("AnlagenbeschreibungService.saveSingularCapitalized#() itemToSave after DateTimeOffset-Fix:", itemToSave);

    if (anlagenbeschreibung.id === 0) {
      return this.createAnlagenbeschreibung(itemToSave);
    }

    return this.updateAnlagenbeschreibung(itemToSave)

  }

  updateAnlagenbeschreibung(anlagenbeschreibung: IAnlagenbeschreibung): Observable<IAnlagenbeschreibung> {

    return this.httpClient.put<IAnlagenbeschreibung>(this.apiBaseUrl + 'anlagenbeschreibung/' + anlagenbeschreibung.id, anlagenbeschreibung, { headers: httpOptions, observe: 'body', withCredentials: true })
    .pipe(catchError(this.handleError))

  }

  deleteAnlagenbeschreibung(id: number) {

    return this.httpClient.delete(this.apiBaseUrl + 'anlagenbeschreibung/' + id, { headers: httpOptions, observe: 'body', withCredentials: true })
      .pipe(
        catchError(this.handleError)
      )
  }

  createAnlagenbeschreibung(anlagenbeschreibung: IAnlagenbeschreibung): Observable<IAnlagenbeschreibung> {
    return this.httpClient.post<IAnlagenbeschreibung>(this.apiBaseUrl + 'anlagenbeschreibung', anlagenbeschreibung, { headers: httpOptions, observe: 'body', withCredentials: true })
      .pipe(map((response) => response), catchError(this.handleError))
  }*/

  initializeAnlagenbeschreibung(): IAnlagenbeschreibung {
    return {
      anlagentyp: '',
      bezeichnung: '',
      createdBy: '',
      created: '',
      modifiedBy: '',
      modified: '',
      rowVersion: '',
      summary: ''
    };
  }


}
